/* Flooring Surgeons – article reading helpers (progressive: the page works fully without this file).
   1. --fs-sticky-header-h: height of the header pinned at the top (same idea as fs-pdp.js) so the sticky TOC and
      heading anchors land below it.  2. Reading progress bar.  3. Active section in the TOC.
   4. Share (Web Share API, else copy link).  5. Click-to-load YouTube (youtube-nocookie). */
(() => {
  const root = document.documentElement;

  // 1. sticky header offset
  const header = document.querySelector('.section-header');
  const compact = document.getElementById('FsCompactHeader');
  let lastH = -1;
  const measure = () => {
    let h = 0;
    if (compact && root.classList.contains('fs-compact-on')) h = compact.offsetHeight;
    else if (header && header.classList.contains('shopify-section-header-sticky') && !header.classList.contains('shopify-section-header-hidden')) h = header.offsetHeight;
    if (h !== lastH) root.style.setProperty('--fs-sticky-header-h', `${(lastH = h)}px`);
  };
  const mo = new MutationObserver(measure);
  mo.observe(root, { attributes: true, attributeFilter: ['class'] });
  if (header) mo.observe(header, { attributes: true, attributeFilter: ['class'] });
  if (window.ResizeObserver) new ResizeObserver(measure).observe(header || root);
  measure();

  // 2. progress through the article text
  const bar = document.querySelector('.fsb-progress');
  const text = document.querySelector('.fsb-prose');
  if (bar && text) {
    let ticking = false;
    const update = () => {
      ticking = false;
      const r = text.getBoundingClientRect();
      const total = r.height - innerHeight * 0.6;
      const p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
      bar.style.setProperty('--fsb-p', p.toFixed(4));
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  // 3. active TOC entry
  const links = [...document.querySelectorAll('.fsb-toc ol a[href^="#"]')].filter((a) => a.hash.length > 1);
  if (links.length && 'IntersectionObserver' in window) {
    const map = new Map();
    links.forEach((a) => { const h = document.getElementById(decodeURIComponent(a.hash.slice(1))); if (h) map.set(h, a); });
    const setActive = () => {
      let current = null;
      for (const h of map.keys()) if (h.getBoundingClientRect().top < innerHeight * 0.35) current = h;
      const active = current && map.get(current);
      links.forEach((a) => {
        a.classList.toggle('is-active', a === active);
        if (a === active) a.setAttribute('aria-current', 'location');
        else a.removeAttribute('aria-current');
      });
    };
    const io = new IntersectionObserver(setActive, { rootMargin: '0px 0px -60% 0px' });
    map.forEach((_, h) => io.observe(h));
  }
  // close the phone TOC after a jump
  document.querySelectorAll('.fsb-toc-m a').forEach((a) => a.addEventListener('click', () => a.closest('details')?.removeAttribute('open')));

  // 4. share
  document.querySelectorAll('[data-fsb-share]').forEach((btn) => {
    const label = btn.querySelector('[data-fsb-share-label]');
    const original = label?.textContent;
    btn.hidden = false;
    btn.addEventListener('click', async () => {
      const data = { title: document.title, url: location.href.split('#')[0] };
      if (navigator.share) { try { await navigator.share(data); } catch (e) {} return; }
      try { await navigator.clipboard.writeText(data.url); if (label) label.textContent = 'Link copied'; } catch (e) { prompt('Copy this link', data.url); }
      setTimeout(() => label && (label.textContent = original), 2200);
    });
  });

  // 5. click-to-load video
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.fs-video a');
    if (!link) return;
    const fig = link.closest('.fs-video');
    const id = fig.dataset.yt;
    if (!id) return;
    e.preventDefault();
    const f = document.createElement('iframe');
    f.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
    f.title = link.querySelector('img')?.alt || 'Video';
    f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    f.allowFullscreen = true;
    link.replaceWith(f);
  });
})();
